var _polygon, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorDutyFree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "38.449 39.128 3.551 39.128 7.706 12.882 34.294 12.882 38.449 39.128"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m13.681,17.509v-7.319c0-4.042,3.277-7.319,7.319-7.319h0c4.042,0,7.319,3.277,7.319,7.319v7.319"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorDutyFree);
export default __webpack_public_path__ + "static/media/indoor-duty_free.b545663feaf8a3249a7dd86eca17270e.svg";
export { ForwardRef as ReactComponent };